import ApiService from "@/core/services/ApiService";
import { Actions, APIEndpoints } from "@/store/enums/StoreEnums";
import {
  Module,
  Action,
  Mutation,
  VuexModule,
  config,
} from "vuex-module-decorators";

config.rawError = true;

@Module
export default class PaymentModule extends VuexModule {
  @Action({ rawError: true })
  [Actions.GET_PAYMENTS]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get("/attorney/" + APIEndpoints.PAYMENTS)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_PAYMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(`/attorney/${APIEndpoints.PAYMENTS}/${payload.paymentId}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.ADD_PAYMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post("/attorney/" + APIEndpoints.PAYMENTS, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.UPDATE_PAYMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.PAYMENTS}/${payload.paymentId}`,
        payload
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
